module.exports = __webpack_public_path__ + "img/green-xml.d9ab3205.svg";